import { render, staticRenderFns } from "./ClinicTitle.vue?vue&type=template&id=b1531cde&scoped=true&lang=pug&"
import script from "./ClinicTitle.vue?vue&type=script&lang=js&"
export * from "./ClinicTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1531cde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
